
export const fixRoute = () => {
    const slashesRegex = /\/{2,}/;
    if (slashesRegex.test(window.location.pathname)) {
        document.location.href = "/";
    }
}
